import React from 'react';
import { Dialog, Box } from '@primer/react';
import PrintPage, { IPrintPageConfig } from '../print-page/PrintPage';
import { useWindowSize } from '../../hooks/useWindowSize';

interface IPrintDialogOptions {
  title?: string;
  htmlContent: string;
  config?: IPrintPageConfig;
  onPrint?: () => void;
  onSendEmail?: () => void;
}

interface IPrintDialogProps {
  isOpen: boolean;
  onClose: () => void;
  options: IPrintDialogOptions;
}

const PrintDialog: React.FC<IPrintDialogProps> = ({ isOpen, onClose, options }) => {
  const { title = "In tài liệu", htmlContent, config, onPrint, onSendEmail } = options;
  const {height} = useWindowSize();
  return (
    <Dialog isOpen={isOpen} onDismiss={onClose} sx={{
        zIndex: 9999,
        width: config?.isLandscape ? '1123px' : '794px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        margin: 0,
        maxHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
      <Dialog.Header>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <i className="fa fa-print" style={{ fontSize: 16 }} />
          {title}
        </Box>
      </Dialog.Header>
  
     
        <Box>
          <PrintPage
            htmlTemplate={htmlContent}
            title={title}
            config={config}
            onPrint={() => {
              onPrint?.();
              onClose();
            }}
            onSendEmail={() => {
              onSendEmail?.();
              onClose();
            }}
            showPreview={true}
          />
        </Box>
    
    </Dialog>
  );
};

export default PrintDialog;